import { useCompanyId } from '@cliengo/mfe-utils/hooks';
import { usePermissionsService } from '@cliengo/mfe-utils/services';

import { Flex } from '../utils';

import { LobbyCard } from './LobbyCard';

import * as events from '@/utils/eventTracker';
import { Show } from '@/ui/Show';
import { useTranslate } from '@/hooks';

export const CampaignsLobby = () => {
  const companyId = useCompanyId();
  const permissions = usePermissionsService();
  const { t } = useTranslate('lobbys');

  return (
    <Flex gap="1rem" p="25px" id="lobby-container-campaigns">
      <Show
        when={permissions.hasOneOf([
          'admin',
          'reseller_admin',
          'websites_write',
        ])}
      >
        <LobbyCard
          title="Google Ads"
          description={t('campaigns.adsDescription')}
          to={`/campaigns/${companyId}`}
          onClick={events.goToGads}
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              viewBox="0 0 60 60"
              fill="none"
            >
              <mask
                id="mask0_1699_3791"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="60"
                height="60"
              >
                <rect width="60" height="60" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_1699_3791)">
                <path
                  d="M14.9999 35H22.6874L35.1301 22.5C35.5033 22.125 35.7833 21.6979 35.97 21.2188C36.1566 20.7396 36.2499 20.2708 36.2499 19.8125C36.2499 19.3542 36.1666 18.8958 35.9999 18.4375C35.8332 17.9792 35.5624 17.5625 35.1874 17.1875L32.8874 14.8631C32.5041 14.496 32.0832 14.2188 31.6249 14.0313C31.1666 13.8438 30.6874 13.75 30.1874 13.75C29.7291 13.75 29.2707 13.8333 28.8124 14C28.3541 14.1667 27.9365 14.4375 27.5597 14.8125L14.9999 27.3125V35ZM18.7499 31.25V28.875L25.1249 22.5625L26.3124 23.6875L27.4374 24.875L21.1249 31.25H18.7499ZM26.3124 23.6875L27.4374 24.875L25.1249 22.5625L26.3124 23.6875ZM27.1874 35H44.9999V31.25H30.9374L27.1874 35ZM4.99991 55V8.75002C4.99991 7.75002 5.37491 6.87502 6.12491 6.12502C6.87491 5.37502 7.74991 5.00002 8.74991 5.00002H51.2499C52.2499 5.00002 53.1249 5.37502 53.8749 6.12502C54.6249 6.87502 54.9999 7.75002 54.9999 8.75002V41.25C54.9999 42.25 54.6249 43.125 53.8749 43.875C53.1249 44.625 52.2499 45 51.2499 45H14.9999L4.99991 55ZM13.3749 41.25H51.2499V8.75002H8.74991V46.25L13.3749 41.25Z"
                  fill="#4A4458"
                />
              </g>
            </svg>
          }
          cta={t('seeMore')}
        />
      </Show>
      <LobbyCard
        title={t('campaigns.outgoingTitle')}
        description={t('campaigns.outgoingDescription')}
        to="/campaigns/hsm"
        onClick={events.goToHsm}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
          >
            <mask
              id="mask0_1699_3783"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="60"
              height="60"
            >
              <rect width="60" height="60" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1699_3783)">
              <path
                d="M15 35.0625H34.5625V31.3125H15V35.0625ZM15 26.9375H45V23.1875H15V26.9375ZM15 18.8125H45V15.0625H15V18.8125ZM4.99997 55V8.75C4.99997 7.75 5.37497 6.875 6.12497 6.125C6.87497 5.375 7.74997 5 8.74997 5H51.25C52.25 5 53.125 5.375 53.875 6.125C54.625 6.875 55 7.75 55 8.75V41.25C55 42.25 54.625 43.125 53.875 43.875C53.125 44.625 52.25 45 51.25 45H15L4.99997 55ZM13.375 41.25H51.25V8.75H8.74997V46.25L13.375 41.25Z"
                fill="#4A4458"
              />
            </g>
          </svg>
        }
        cta={t('seeMore')}
      />
    </Flex>
  );
};
